// @ts-nocheck
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import Page from '../../components/library/Page';
import Title from '../../components/library/Title';
import ConstantValues from '../../constants/ConstantValues';
import { SEO } from '../../common';
import { formatSEOTitle } from '../../function';
import { useTranslation } from 'react-i18next';

function ImageFormats(){
  const { t } = useTranslation();

  useEffect(() => {
    if (document.location.hostname === ConstantValues.SiteHostname) { 
      ReactGA.pageview(window.location.pathname);
    }
  },[]);

  const Content = () => {
    return(
      <>
        <Title type="sub" title={t('image_formats_what_are_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '20px'}}>
          {t('image_formats_what_are_description')}
        </Typography>

        <Title type="sub" title={t('image_formats_comparison_title')}/>
        
        <Grid container spacing={3} style={{marginBottom: '30px'}}>
          <Grid item xs={12} md={6}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h5" component="h2" gutterBottom color="primary">
                  {t('image_formats_png_title')}
                </Typography>
                <Typography variant="body1" gutterBottom style={{marginBottom: '15px'}}>
                  {t('image_formats_png_description')}
                </Typography>
                
                <Typography variant="h6" gutterBottom style={{color: '#2e7d32'}}>{t('image_formats_png_features_title')}</Typography>
                <ul style={{marginBottom: '15px'}}>
                  <li><Typography variant="body2">{t('image_formats_png_feature_1')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_png_feature_2')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_png_feature_3')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_png_feature_4')}</Typography></li>
                </ul>

                <Typography variant="h6" gutterBottom style={{color: '#d32f2f'}}>{t('image_formats_png_uses_title')}</Typography>
                <ul style={{marginBottom: '15px'}}>
                  <li><Typography variant="body2">{t('image_formats_png_use_1')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_png_use_2')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_png_use_3')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_png_use_4')}</Typography></li>
                </ul>

                <Typography variant="h6" gutterBottom style={{color: '#f57c00'}}>{t('image_formats_png_limitations_title')}</Typography>
                <Typography variant="body2">
                  {t('image_formats_png_limitations')}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h5" component="h2" gutterBottom color="primary">
                  {t('image_formats_webp_title')}
                </Typography>
                <Typography variant="body1" gutterBottom style={{marginBottom: '15px'}}>
                  {t('image_formats_webp_description')}
                </Typography>

                <Typography variant="h6" gutterBottom style={{color: '#2e7d32'}}>{t('image_formats_webp_features_title')}</Typography>
                <ul style={{marginBottom: '15px'}}>
                  <li><Typography variant="body2">{t('image_formats_webp_feature_1')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_webp_feature_2')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_webp_feature_3')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_webp_feature_4')}</Typography></li>
                </ul>

                <Typography variant="h6" gutterBottom style={{color: '#d32f2f'}}>{t('image_formats_webp_uses_title')}</Typography>
                <ul style={{marginBottom: '15px'}}>
                  <li><Typography variant="body2">{t('image_formats_webp_use_1')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_webp_use_2')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_webp_use_3')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_webp_use_4')}</Typography></li>
                </ul>

                <Typography variant="h6" gutterBottom style={{color: '#f57c00'}}>{t('image_formats_webp_limitations_title')}</Typography>
                <Typography variant="body2">
                  {t('image_formats_webp_limitations')}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h5" component="h2" gutterBottom color="primary">
                  {t('image_formats_jpeg_title')}
                </Typography>
                <Typography variant="body1" gutterBottom style={{marginBottom: '15px'}}>
                  {t('image_formats_jpeg_description')}
                </Typography>

                <Typography variant="h6" gutterBottom style={{color: '#2e7d32'}}>{t('image_formats_jpeg_features_title')}</Typography>
                <ul style={{marginBottom: '15px'}}>
                  <li><Typography variant="body2">{t('image_formats_jpeg_feature_1')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_jpeg_feature_2')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_jpeg_feature_3')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_jpeg_feature_4')}</Typography></li>
                </ul>

                <Typography variant="h6" gutterBottom style={{color: '#d32f2f'}}>{t('image_formats_jpeg_uses_title')}</Typography>
                <ul style={{marginBottom: '15px'}}>
                  <li><Typography variant="body2">{t('image_formats_jpeg_use_1')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_jpeg_use_2')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_jpeg_use_3')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_jpeg_use_4')}</Typography></li>
                </ul>

                <Typography variant="h6" gutterBottom style={{color: '#f57c00'}}>{t('image_formats_jpeg_limitations_title')}</Typography>
                <Typography variant="body2">
                  {t('image_formats_jpeg_limitations')}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card elevation={3}>
              <CardContent>
                <Typography variant="h5" component="h2" gutterBottom color="primary">
                  {t('image_formats_gif_title')}
                </Typography>
                <Typography variant="body1" gutterBottom style={{marginBottom: '15px'}}>
                  {t('image_formats_gif_description')}
                </Typography>

                <Typography variant="h6" gutterBottom style={{color: '#2e7d32'}}>{t('image_formats_gif_features_title')}</Typography>
                <ul style={{marginBottom: '15px'}}>
                  <li><Typography variant="body2">{t('image_formats_gif_feature_1')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_gif_feature_2')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_gif_feature_3')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_gif_feature_4')}</Typography></li>
                </ul>

                <Typography variant="h6" gutterBottom style={{color: '#d32f2f'}}>{t('image_formats_gif_uses_title')}</Typography>
                <ul style={{marginBottom: '15px'}}>
                  <li><Typography variant="body2">{t('image_formats_gif_use_1')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_gif_use_2')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_gif_use_3')}</Typography></li>
                  <li><Typography variant="body2">{t('image_formats_gif_use_4')}</Typography></li>
                </ul>

                <Typography variant="h6" gutterBottom style={{color: '#f57c00'}}>{t('image_formats_gif_limitations_title')}</Typography>
                <Typography variant="body2">
                  {t('image_formats_gif_limitations')}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Title type="sub" title={t('image_formats_decision_matrix_title')}/>
        <Paper elevation={2} style={{padding: '20px', marginBottom: '30px'}}>
          <Typography variant="h6" gutterBottom>{t('image_formats_decision_guide')}</Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Paper elevation={1} style={{padding: '15px', backgroundColor: '#e3f2fd'}}>
                <Typography variant="h6" color="primary" gutterBottom>{t('image_formats_transparency_title')}</Typography>
                <Typography variant="body2"><strong>{t('image_formats_transparency_best')}</strong></Typography>
                <Typography variant="body2"><strong>{t('image_formats_transparency_avoid')}</strong></Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Paper elevation={1} style={{padding: '15px', backgroundColor: '#e8f5e8'}}>
                <Typography variant="h6" color="primary" gutterBottom>{t('image_formats_photography_title')}</Typography>
                <Typography variant="body2"><strong>{t('image_formats_photography_best')}</strong></Typography>
                <Typography variant="body2"><strong>{t('image_formats_photography_avoid')}</strong></Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Paper elevation={1} style={{padding: '15px', backgroundColor: '#fff3e0'}}>
                <Typography variant="h6" color="primary" gutterBottom>{t('image_formats_animation_title')}</Typography>
                <Typography variant="body2"><strong>{t('image_formats_animation_best')}</strong></Typography>
                <Typography variant="body2"><strong>{t('image_formats_animation_avoid')}</strong></Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Paper elevation={1} style={{padding: '15px', backgroundColor: '#fce4ec'}}>
                <Typography variant="h6" color="primary" gutterBottom>{t('image_formats_filesize_title')}</Typography>
                <Typography variant="body2"><strong>{t('image_formats_filesize_best')}</strong></Typography>
                <Typography variant="body2"><strong>{t('image_formats_filesize_largest')}</strong></Typography>
              </Paper>
            </Grid>
          </Grid>
        </Paper>

        <Title type="sub" title={t('image_formats_tech_specs_title')}/>
        <div style={{overflowX: 'auto', marginBottom: '30px'}}>
          <table style={{width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd'}}>
            <thead>
              <tr style={{backgroundColor: '#f5f5f5'}}>
                <th style={{padding: '12px', border: '1px solid #ddd', textAlign: 'left'}}>{t('image_formats_tech_feature')}</th>
                <th style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>PNG</th>
                <th style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>WEBP</th>
                <th style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>JPEG</th>
                <th style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>GIF</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>{t('image_formats_tech_compression')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_lossless')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_both')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_lossy')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_lossless')}</td>
              </tr>
              <tr style={{backgroundColor: '#fafafa'}}>
                <td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>{t('image_formats_tech_transparency')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_alpha')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_alpha')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_no')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_binary')}</td>
              </tr>
              <tr>
                <td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>{t('image_formats_tech_animation')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_no')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_yes')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_no')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_yes')}</td>
              </tr>
              <tr style={{backgroundColor: '#fafafa'}}>
                <td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>{t('image_formats_tech_colors')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_colors_full')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_colors_full')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_colors_full')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_colors_limited')}</td>
              </tr>
              <tr>
                <td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>{t('image_formats_tech_browser')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_universal')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_modern')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_universal')}</td>
                <td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>{t('image_formats_tech_universal')}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <Title type="sub" title={t('image_formats_performance_title')}/>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '20px'}}>
          {t('image_formats_performance_description')}
        </Typography>

        <Grid container spacing={3} style={{marginBottom: '30px'}}>
          <Grid item xs={12} md={4}>
            <Paper elevation={2} style={{padding: '20px', height: '100%'}}>
              <Typography variant="h6" gutterBottom color="secondary">{t('image_formats_loading_title')}</Typography>
              <Typography variant="body2">
                {t('image_formats_loading_description')}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper elevation={2} style={{padding: '20px', height: '100%'}}>
              <Typography variant="h6" gutterBottom color="secondary">{t('image_formats_mobile_title')}</Typography>
              <Typography variant="body2">
                {t('image_formats_mobile_description')}
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper elevation={2} style={{padding: '20px', height: '100%'}}>
              <Typography variant="h6" gutterBottom color="secondary">{t('image_formats_seo_title')}</Typography>
              <Typography variant="body2">
                {t('image_formats_seo_description')}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <div style={{marginTop: '40px'}}>
          <Title type="sub" title={t('image_formats_future_title')}/>
        </div>
        <Typography variant="body1" gutterBottom component="div" style={{marginBottom: '20px'}}>
          {t('image_formats_future_description')}
        </Typography>

        <ul style={{marginLeft: '20px', marginBottom: '20px'}}>
          <li><Typography variant="body1"><strong>{t('image_formats_future_avif')}</strong></Typography></li>
          <li><Typography variant="body1"><strong>{t('image_formats_future_heif')}</strong></Typography></li>
          <li><Typography variant="body1"><strong>{t('image_formats_future_svg')}</strong></Typography></li>
        </ul>

        <Divider style={{margin: '30px 0'}} />

        <div style={{padding: '25px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef'}}>
          <Typography variant="h6" gutterBottom style={{color: '#495057'}}>{t('image_formats_conclusion_title')}</Typography>
          <Typography variant="body1" style={{color: '#6c757d'}}>
            {t('image_formats_conclusion_description')}
          </Typography>
        </div>
      </>
    );
  };

  return(
    <Page pageTitle={t('image_formats_page_title')}>
      <SEO
        title={formatSEOTitle(t('image_formats_page_title') + ' | Signal Sticker Maker')}
        description='Complete guide to choosing image formats for custom stickers and messaging apps. Learn PNG, WEBP, JPEG, GIF differences for Signal sticker maker and other sticker tools.'
      />
      <Content/>
    </Page>
  );
}

export default ImageFormats;
